import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./lib/immer-config"; // Must be imported first to enable MapSet
import "./index.css";
import App from "./App.tsx";

// Conditional StrictMode - can be disabled for complex real-time applications
const isDevelopment = import.meta.env.DEV;
const enableStrictMode = isDevelopment && !import.meta.env.VITE_DISABLE_STRICT_MODE;

const AppWrapper = () => {
  return enableStrictMode ? (
    <StrictMode>
      <App />
    </StrictMode>
  ) : (
    <App />
  );
};

createRoot(document.getElementById("root")!).render(
  <AppWrapper />
);
